import React from "react";
import { FieldTypePill } from "@smartsuite/react-ui/lib/components/widgets/FieldTypePill/FieldTypePill";
export const PillNodeView = ({ view, attrs, getPos, }) => {
    const { icon, title, invalid } = attrs;
    const isRemovable = view.editable;
    const handleRemove = () => {
        const pos = getPos();
        view.dispatch(view.state.tr.deleteRange(pos, pos + 1));
        view.focus();
    };
    return (React.createElement(FieldTypePill, { className: "pill-node-view", icon: icon, title: title, isError: invalid, isRemovable: isRemovable, onRemove: handleRemove }));
};
